import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '@services/hooks/profile';

export const useSupervisorCollection = (): {
	isProfileLoaded: boolean;
	isRBDM: boolean;
	userRole: string;
} => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	// Wait for profile to load before determining user role
	const isProfileLoaded = profile && profile.length > 0;
	const userRole = isProfileLoaded ? profile[0]?.usertype_c : '';
	const isRBDM = userRole === 'RBDM';

	return {
		isProfileLoaded,
		isRBDM,
		userRole,
	};
};
